import { fg } from '@atlaskit/platform-feature-flags';
var buffer = [];
var push = function push(payload) {
  buffer.push(payload);
};
export function reportError(payload) {
  push(payload);
}
export function installErrorHandler(handler) {
  if (fg('moving_jira_entry-points_api_under_platform')) {
    push = handler;
    buffer.forEach(function (payload) {
      return handler(payload);
    });
    buffer.length = 0;
  }
}